import React from "react";
import { BillingMethodSection } from "./sections/BillingMethodSection";
import { BillingHistorySection } from "./sections/BillingHistorySection";

export const BillingTab: React.FC = () => {
  return (
    <div className="flex flex-col gap-8">
      {/* Billing Method Section */}
      <BillingMethodSection />

      {/* Billing History Section */}
      <BillingHistorySection />
    </div>
  );
};
